export interface iAsideSettings {
  Show: string;
  SetShow: (newState:string) => void;
}

export const initialAsideSettingsValues: iAsideSettings = {
  Show: '',
  SetShow: (newState:string) => {}
}
